import { api as r } from "../utils/configuration.js";
import { crudService as o } from "../js/request-zRag5cDd.js";
const m = {
  getEnvironmentConfig: (e) => o.get(`${r.SYSTEM_URL}`, { signal: e })
};
export {
  m as SystemService
};
//# sourceMappingURL=system.js.map
